import api from './axios';
import { API_ENDPOINTS } from '../constants';
import { logError } from '../common/utils/logger';

/**
 * Fetches journey masters from a unified backend endpoint.
 *
 * @param {string} masterType - Master selector (e.g. bankdetails, statedetails, relationshipdetails)
 * @param {Object|string|null} [options] - Query options or legacy OData filter string
 * @returns {Promise<Object>} API response with masterType, items and totalCount
 */
export const fetchJourneyMasters = async (masterType, options = {}) => {
  try {
    if (!masterType || !String(masterType).trim()) {
      throw new Error('masterType is required.');
    }

    const opts =
      typeof options === 'object' && options !== null ? options : { filter: options };

    const params = { masterType: String(masterType).trim() };

    if (opts.filter && String(opts.filter).trim()) {
      params.filter = String(opts.filter).trim();
    }
    if (opts.stateID != null && String(opts.stateID).trim()) {
      params.stateID = String(opts.stateID).trim();
    }
    if (opts.pincodePrefix != null && String(opts.pincodePrefix).trim()) {
      params.pincodePrefix = String(opts.pincodePrefix).trim();
    }
    if (opts.organizationPrefix != null && String(opts.organizationPrefix).trim()) {
      params.organizationPrefix = String(opts.organizationPrefix).trim();
    }
    if (opts.pincodeState != null && String(opts.pincodeState).trim()) {
      params.pincodeState = String(opts.pincodeState).trim();
    }
    if (opts.pincodeCity != null && String(opts.pincodeCity).trim()) {
      params.pincodeCity = String(opts.pincodeCity).trim();
    }
    if (opts.organizationExact === true) {
      params.organizationExact = true;
    }

    const response = await api.get(API_ENDPOINTS.JOURNEY_MASTERS, { params });
    return response?.data ?? null;
  } catch (error) {
    logError('[fetchJourneyMasters] Failed to fetch journey masters', error);
    throw error;
  }
};
